module.exports = __webpack_public_path__ + "img/erweima.78ce995e.jpg";